import SubscriptionProxyHandler from "@mrwa/rime-replacement/infrastructure/subscriptionProxy";
import crashDetailsState from "@mrwa/crashmap/esriControls/crashmapTools/crashDetailsState";
import { getAuthToken } from "../Auth";

/**
 * Used for maintaining crash and vehicle detail state
 */
class crashState extends crashDetailsState {
  constructor() {
    super();
    this.accountId = null;
    this.roadViewVehicleDetailsUrl = null;
    this.initialised = false;
  }

  initialise(props) {
    this.roadViewVehicleDetailsUrl = props.roadViewVehicleDetailsUrl;
    this.accountId = props.accountId;
    this.initialised = true;
  }

  get vehicleDetailsQueryUrl() {
    if (!this.initialised) throw new Error("Crash State not initialised.");
    return this.roadViewVehicleDetailsUrl;
  }

  async queryHeader() {
    if (!this.initialised) throw new Error("Crash State not initialised.");
    return {
      headers: {
        Authorization: `Bearer ${await getAuthToken(this.accountId)}`,
      },
    };
  }
}

export default new Proxy(new crashState(), new SubscriptionProxyHandler());
